export const runReducersFirst = (next, action) => {
  return next(action);
};